<template>
  <div class="app bg-gray">
    <!-- 医生信息 -->
    <section class="doctor-info thick">
      <div
        class="head doc-header"
        v-bind:style="{
          backgroundImage:
            'url(' +
            (registInfo.doc.doctAvatar
              ? registInfo.doc.doctAvatar
              : '../../../static/img/ico-doctor.png') +
            ')',
        }"
      >
        <!-- 门诊类型标签 -->
        <span
          v-if="registInfo.doc.typeId === '849772'"
          class="type-tag tag-putong"
          >{{ registInfo.doc.typeName }}</span
        >
        <span
          v-if="registInfo.doc.typeId === '643075'"
          class="type-tag tag-zhuanjia"
          >{{ registInfo.doc.typeName }}</span
        >
      </div>
      <div class="info">
        <p style="padding-right: 0.5rem">
          <span class="f-large f-normal" style="margin-right: 0.25rem">{{
            registInfo.doc.rankName
          }}</span>
          <span class="f-large f-normal">{{ registInfo.doc.doctName }}</span>
        </p>
        <p class="f-small f-minor">{{ registInfo.depart.deptName }}</p>
      </div>
    </section>
    <!-- tab标签 -->
    <!--<section class="thick">-->
    <!--<ul class="tab-top">-->
    <!--<li @click="onSelectedTab(item)" v-for="item in tabs" class="tab-item" :id="'register-departDoctor-tab-'+item.tabId"-->
    <!--:class="{ 'active': selectedTab.tabId == item.tabId }">-->
    <!--<span class="tab-label">{{item.tabName}}</span>-->
    <!--</li>-->
    <!--</ul>-->
    <!--</section>-->
    <section>
      <section class="thick">
        <p
          class="panel f-minor bg-gray"
          @click="showTimeTable = !showTimeTable"
        >
          当日排版表
          <span
            v-show="!showTimeTable"
            class="pull-right arr-gray-down"
            style="margin-top: 0.4rem"
          ></span>
          <span
            v-show="showTimeTable"
            class="pull-right arr-gray-up"
            style="margin-top: 0.4rem"
          ></span>
          <span class="pull-right f-strong">更多日期</span>
        </p>
        <!-- 时间选择 -->
        <time-table
          v-show="showTimeTable"
          @change="loadTimeSchedules"
          :areaId="registInfo.area.areaId"
          :deptId="registInfo.depart.deptId"
        ></time-table>
      </section>
      <!-- 预约信息 -->
      <section class="thick">
        <p class="panel">
          预约日期<span class="pull-right"
            >{{ registInfo.date.value | formatDate }}&nbsp;&nbsp;{{
              registInfo.date.weekDay
            }}</span
          >
        </p>
        <p class="panel">
          <span>挂号金额：</span
          ><span class="pull-right f-strongest">{{
            registInfo.doc.fee | formatFee
          }}</span>
        </p>
      </section>
      <!-- 时段列表 -->
      <scroll @refresh="refresh" style="position: relative">
        <ul class="list">
          <li
            v-for="schedule in schedules"
            class="list-item"
            :class="{ 'arr-item-blue': schedule.status === 1 }"
            @click="onSelected(schedule)"
          >
            <span>{{ schedule.timeslot }}</span>
            <span v-if="schedule.status === 1" class="pull-right f-strong">{{
              registInfo.date.value | isToday
            }}</span>
            <span
              v-if="schedule.status === 2"
              class="pull-right f-minor"
              style="padding-right: 0.79rem"
              >满诊</span
            >
            <span
              v-if="schedule.status === 3"
              class="pull-right f-identify"
              style="padding-right: 0.79rem"
              >停诊</span
            >
          </li>
        </ul>
      </scroll>
    </section>
    <!--<div class="doct-desc row" v-if="selectedTab.tabId === 1">-->
    <!--{{doctDesc ? doctDesc : "暂无医生介绍"}}-->
    <!--</div>-->
  </div>
</template>

<script>
import registerService from 'register.service';
import TimeTable from 'TimeTable'
export default {
  components: {
    TimeTable,
  },
  mounted () {
    this.refresh();
  },

  data () {
    var params = this.$store.state.paramModule.param.register;
    return {
      // tabs: [{'tabId': 0, 'tabName': '门诊排班', 'searchText': '输入二级科室', 'noRecordText':'查找不到科室，请重新输入'},
      //     {'tabId': 1, 'tabName': '医生介绍', 'searchText': '输入医生姓名', 'noRecordText':'查找不到医生，请重新输入'}],
      // selectedTab: {'tabId': 0, 'tabName': '门诊排班'},
      // doctDesc:this.$store.state.paramModule.param.register.doc.doctDesc,
      hospitalName: JSON.parse(localStorage.selectedHospital).hospitalName || "",
      registInfo: params,
      schedules: [],
      showTimeTable: false,
    }
  },
  methods: {
    refresh () {
      this.loadTimeSchedules();
    },
    loadTimeSchedules: function () {
      //加载前清空排班数据
      this.schedules = [];
      var params = this.$store.state.paramModule.param.register;
      var requestParams = {
        areaId: params.area.areaId,
        deptId: params.depart.deptId,
        regDate: params.date.value,
        doctId: params.doc.doctId,
        rankId: params.doc.rankId
      }
      registerService.loadTimeSchedules(requestParams).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }
        var typeId = this.registInfo.doc.typeId;
        var typeName = this.registInfo.doc.typeName;
        var deptId = this.registInfo.depart.deptId;
        var deptName = this.registInfo.depart.deptName;
        this.schedules = res.data ? this.transTimeSlots(res.data, typeId, typeName, deptId, deptName) : [];
      })
    },
    transTimeSlots: function (timeSchedule, typeId, typeName, deptId, deptName) {
      var slots = timeSchedule.timeTablesList;
      if (!slots) {
        return [];
      }
      function buildSlot (item) {
        return {
          deptId: deptId,
          deptName: deptName,
          typeId: typeId,
          typeName: typeName,
          doctId: timeSchedule.doctId,
          doctName: timeSchedule.doctName,
          rankId: timeSchedule.rankId,
          rankName: timeSchedule.rankName,
          timeslot: item.startTime.substring(0, 5) + "-" + item.endTime.substring(0, 5),
          startTime: item.startTime,
          endTime: item.endTime,
          status: item.status,
          phaseId: item.phaseId,
          regSourceId: item.regSourceId,
          fee: item.fee,
          ordNum: item.ordNum
        };
      }
      var schedules = [];
      slots.forEach(function (item) {
        var slot = buildSlot(item);
        schedules.push(slot);
      });
      return schedules;
    },

    onSelected: function (schedule) {
      if (!this.isRegisterStatus(schedule.status)) {
        return;
      }
      this.$store.commit('updateParam', {
        namespace: 'register',
        schedule: schedule
      })
      this.$router.push({
        name: 'registConfirm'
      });
    },
    isRegisterStatus: function (status) {
      return status === 1;
    },
    // onSelectedTab: function(item) {
    //     this.selectedTab = item;
    // },
  }
}
</script>

<style lang="scss" >
@import "../../../static/sass/_variable.scss";
.doct-desc {
  margin-top: -5px;
  overflow-y: auto;
  word-break: break-all;
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// TimeSchedule.vue?295f5042